interface ArticleBodyProps {
  content: string[];
  image: string;
  imageAlt: string;
}

export default function ArticleBody({ content, image, imageAlt }: ArticleBodyProps) {
  return (
    <article className="space-y-4 text-[15px] leading-[1.9] text-foreground-800">
      {content.map((para, i) => (
        <div key={`para-${i}-${para.slice(0, 6)}`}>
          <p className="indent-8 md:indent-0">{para}</p>
          {i === 1 && (
            <figure className="mt-5 overflow-hidden rounded-lg border border-background-200">
              <img src={image} alt={imageAlt} title={imageAlt} className="h-56 w-full object-cover object-top md:h-80" />
              <figcaption className="bg-background-100 px-4 py-2 text-center text-xs text-secondary-500">
                {imageAlt}（示意图）
              </figcaption>
            </figure>
          )}
        </div>
      ))}
    </article>
  );
}